import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-bottom",
  "use": "arrow-bottom-usage",
  "viewBox": "0 0 13 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 8\" id=\"arrow-bottom\"><path d=\"m2.115.295-1.41 1.41 6 6 6-6-1.41-1.41-4.59 4.58-4.59-4.58Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol